export const TAXUALLY_LINK = 'https://learn.taxually.com/epr-backmarket'
